import { render, staticRenderFns } from "./FlashCards.vue?vue&type=template&id=fa0c9cd8&lang=pug&"
import script from "./FlashCards.vue?vue&type=script&lang=js&"
export * from "./FlashCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports